import { render, staticRenderFns } from "./MinimizeWindow.vue?vue&type=template&id=c4d7156c"
import script from "./MinimizeWindow.vue?vue&type=script&lang=js"
export * from "./MinimizeWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports